// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {use_qs} from '../lib/use_qs';
import hopt from 'hola_opt';
// @ts-ignore
import {get} from '/util/util.js';

export const show_download_link = (name, {source, sys, has_svc})=>{
    const {debug_ui} = use_qs();
    if (debug_ui)
        return true;
    const conf = get(hopt, `www_hola.hola_apps.${name}`);
    if (!conf || !conf.show)
        return true;
    const {sources, svc, os} = conf.show;
    return (!sources || sources[source]) &&
        (!Number.isInteger(svc) || has_svc==!!svc) &&
        (!os || os[sys.os]);
};
